export const time = ({
  displayScheduleDays,
  displayScheduleTimeEnabled,
  displayScheduleStartTime,
  displayScheduleEndTime,
  displayScheduleTimeZone,
  editMode
}) => {
  const currentDate = new Date();
  const currentDay = currentDate.getDay();
  const hoursCurrent = Number(currentDate.getHours(), 10);
  const minutesCurrent = Number(currentDate.getMinutes(), 10);
  const currentTimeZone = currentDate.getTimezoneOffset();
  const timeZoneNumber = displayScheduleTimeZone
    ? Number(displayScheduleTimeZone)
    : -currentTimeZone / 60;

  const [hoursStart, minutesStart] = displayScheduleStartTime.time.split(':');
  const [hoursEnd, minutesEnd] = displayScheduleEndTime.time.split(':');

  const getCurrentHour = (hour) => {
    hour -= currentTimeZone / 60 + timeZoneNumber;

    switch (true) {
      case hour < 0:
        hour += 24;
        break;
      case hour >= 24:
        hour -= 24;
        break;
    }

    return hour;
  };

  const hc = Number(hoursCurrent);
  const mc = Number(minutesCurrent);
  const hs = getCurrentHour(Number(hoursStart));
  const ms = Number(minutesStart);
  const he = getCurrentHour(Number(hoursEnd));
  const me = Number(minutesEnd);

  // c - current
  // s - start
  // e - end

  const adapterDisplayDays = (days) => {
    days.forEach((day, index) => {
      if (day === 7) {
        days.unshift(0);
        days.splice(index + 1);
      }
    });

    return days;
  };

  displayScheduleDays = adapterDisplayDays(displayScheduleDays);

  const resolvers = [
    () => he < hs && (hc > hs || hc < he),
    () => he < hs && hc === hs && mc >= ms,
    () => he < hs && hc === he && mc <= me,
    () => hc > hs && hc < he,
    () => hc === hs && hc === he && mc >= ms && mc <= me,
    () => hc === hs && mc >= ms,
    () => hc === he && mc <= me,
    () => [hs, he, ms, me].every((i) => i === 0)
  ];

  if (editMode) {
    return true;
  }

  if (displayScheduleDays.includes(currentDay) && displayScheduleTimeEnabled) {
    for (const resolve of resolvers) {
      if (resolve()) {
        return true;
      }
    }
  } else if (
    displayScheduleDays.includes(currentDay) &&
    !displayScheduleTimeEnabled
  ) {
    return true;
  }

  return false;
};
